





















import InputField from '@/components/InputField'
import TextField from '@/components/TextField'
import Checkbox from '@/components/Checkbox'
import SelectField from '@/components/SelectField'

export default {
    name: 'FormSchema'

    components:
        InputField: InputField
        TextField: TextField
        Checkbox: Checkbox
        SelectField: SelectField

    props: ['id']

    computed:
        isDark: -> @$parent.isDark

    data: ->
        documentId: ''
        fields: @defaultFields()

    methods:
        submit: (e) ->
            e.preventDefault()
            $response = $ @$refs.response
            post =
                'form_id': @id 
                'inputs': $(e.target).serializeArray()
        
            $.ajax 
                type: 'POST'
                url: 'php/contact.php', 
                data: post, 
                success: (data) ->
                    $response.html data 

                    if $response.find '.uk-alert-success' then e.target.reset()

                    $([document.documentElement, document.body]).animate
                        scrollTop: $response.offset().top 
                    , 1000

        defaultFields: ->
            receiver_address: []
            default_subject: []
            contact_fields: []

        setContent: (document) ->
            @documentId = document.id
            fields =
                receiver_address: document.data.receiver_address
                default_subject: document.data.default_subject
                contact_fields: document.data.body
            $.extend @fields, fields

        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response.results then @setContent response.results[0]

    created: ->
        @getContent @id
}
